import { useSelector } from "react-redux";
import Nuclias from "const/nuclias";

const useUser = () => {
  const { user } = useSelector((store) => store.user);
  const userPrivilege = Nuclias.userPermissions[user.privilege.toLowerCase()];

  return {
    user,
    userPrivilege
  };
}

export default useUser;